
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ai/proactive-load-audits",
      function () {
        return require("private-next-pages/en/ai/proactive-load-audits/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ai/proactive-load-audits"])
      });
    }
  